import localforage from 'localforage';

// time is automatically determined by these functions. it is our way to manage "expiration".
// stored, it is the epoch saved.
// however, it can only ever be read. and when read, it represents milliseconds elapsed since last saved.
interface IDBKeyStoreEntry<T> {
  time: number;
  value: T;
}

export function idbKeyValGet<T>(key: string, defaultValue: T): Promise<IDBKeyStoreEntry<T>> {
  return new Promise((resolve) => {
    try {
      localforage
        .getItem(key)
        .then((item) => {
          const formatted = item as IDBKeyStoreEntry<T>;
          const now = new Date().getTime();
          resolve({ time: now - formatted.time, value: formatted.value });
        })
        .catch(() => resolve({ time: 0, value: defaultValue }));
    } catch (_error) {
      resolve({ time: 0, value: defaultValue });
    }
  });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function idbKeyValSet(key: string, value: any): Promise<boolean> {
  return new Promise((resolve) => {
    try {
      localforage
        .setItem(key, { value, time: new Date().getTime() })
        .then(() => resolve(true))
        .catch(() => resolve(false));
    } catch (_error) {
      resolve(false);
    }
  });
}
